import EmptyRouterView from './../views/administrator/EmptyRouterView.vue'
import Administrator from './../views/administrator/Home.vue'
import Stablishment from './../views/administrator/manteiners/stablishment/Stablishment.vue'
import documentType from './../views/administrator/manteiners/document_type/documentType.vue'

import Users from './../views/administrator/manteiners/users/Users.vue'
import Cellar from './../views/administrator/manteiners/cellar/Cellar.vue'
import Remitent from "./../views/administrator/manteiners/remitent/Remitent.vue"
import Distribution from "./../views/administrator/manteiners/distribution/Distribution.vue"

import DocumentHome from './../views/administrator/document/Document.vue'
import DirectoryHome from './../views/administrator/directory/Directory.vue'
import CellarHome from "./../views/administrator/cellar/Cellar.vue"
import TrashDocument from "../views/administrator/TrashDocument/TrashDocument.vue"


export const routes = [
  {
    path: '/administrator',
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'administratorHome',
        component: Administrator,
      },
      {
        path: 'establecimientos',
        name: 'stablishments',
        component: Stablishment
      },
      {
        path: 'bodega',
        name: 'cellar',
        component: Cellar,
        meta: {
          breadcrumb: [
            { name: 'bodega' }
          ]
        }
      },
      {
        path: 'usuarios',
        name: 'users',
        component: Users
      },
      {
        path: "tipo_documento",
        name: "documentType",
        component: documentType
      },
      {
        path: "remitente",
        name: "remitent",
        component: Remitent
      },
      {
        path: 'documentos/:id',
        name: 'documentsAdministrator',
        component: DocumentHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'documentos' }
          ]
        }
      },
      {
        path: 'bodegas',
        name: 'cellarsAdministrator',
        component: CellarHome,
      }, 
      {
        path: 'distribuciones',
        name: 'distributionAdministrator',
        component: Distribution,        
      },
      {
        path: 'directorio/:id',
        name: 'directoryAdministrator',
        component: DirectoryHome,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'directorio' }
          ]
        }
      },
      {
        path: 'eliminados',
        name: 'trashAdministrator',
        component: TrashDocument,
        meta: {
          breadcrumb: [
            { name: 'eliminados' }
          ]
        }
      },

    ]
  },
]